import { render, staticRenderFns } from "./notifyMeList.vue?vue&type=template&id=dd1c1454&"
import script from "./notifyMeList.vue?vue&type=script&lang=js&"
export * from "./notifyMeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports